import CenteredSpinner from "../CenteredSpinner.tsx";
import EmptyState from "../EmptyState.tsx";
import { BackBreadcrumbs, type BackLink } from "../PageHeader.tsx";

interface DetailPageStatusProps {
  isLoading: boolean;
  /** Shown once loading ends without a record. */
  message: string;
  back?: BackLink;
}

/** What a detail page renders while its record loads, or instead of a missing one. */
export default function DetailPageStatus({ isLoading, message, back }: DetailPageStatusProps) {
  if (isLoading) return <CenteredSpinner />;
  return (
    <>
      {back && <BackBreadcrumbs back={back} />}
      <EmptyState variant="panel" title={message} />
    </>
  );
}
